// extracted by mini-css-extract-plugin
export default {"container":"Xp-z","ratingLayout":"Yp-z","ratingLabel":"Zp-z","nonInteractiveRatingLabel":"_p-z"};